import { cn } from "@/lib/utils";

export function CollapseIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn(
        "h-[3px] w-4.5 text-white transition-[colors,filter] group-hover:text-purple-plum group-hover:drop-shadow-[0_0_10px_var(--color-purple-plum)]",
        className
      )}
      viewBox="0 0 18 3"
      {...props}
    >
      <path
        d="M1.5 1.5h15"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="3"
      />
    </svg>
  );
}

export function ExpandIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn(
        "size-4.5 text-white transition-[colors,filter] group-hover:text-purple-plum group-hover:drop-shadow-[0_0_10px_var(--color-purple-plum)]",
        className
      )}
      viewBox="0 0 18 18"
      {...props}
    >
      <path
        d="M9 0a1.125 1.125 0 011.125 1.125v6.75h6.75a1.125 1.125 0 010 2.25h-6.75v6.75a1.125 1.125 0 11-2.25 0v-6.75h-6.75a1.125 1.125 0 110-2.25h6.75v-6.75A1.125 1.125 0 019 0z"
        fill="currentColor"
      />
    </svg>
  );
}
